import {
  Component,
  OnInit,
  Input,
  ViewChild,
  Output,
  EventEmitter
} from "@angular/core";
import { MessageService } from "primeng/api";
import { TechnicianService } from "../../../../services/technician.service";
import { OverlayPanel } from "primeng/overlaypanel";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-technician",
  templateUrl: "./technician.component.html",
  styleUrls: ["./technician.component.scss"]
})
export class TechnicianComponent implements OnInit {
  @Input() user;
  @Input() users;
  @Input() partnerId;
  @Input() messageService: MessageService;
  @Output() update = new EventEmitter();
  @ViewChild("addEvent") addEvent: OverlayPanel;

  leaveEvent=false;
  public technician: any;
  public events: any = [];
  public event: any = {};
  public busyDeleting: boolean = false;
  public busy: boolean = false;
  public error = false;
  public errorMessage = "";
  public eventColumns: any = [
    {
      header: this.translate.instant("general.headers.description"),
      field: "Description",
      type: "string"
    },
    {
      header: this.translate.instant("general.headers.start"),
      field: "StartTime",
      type: "date"
    },
    {
      header: this.translate.instant("general.headers.end"),
      field: "EndTime",
      type: "date"
    },
    {
      header: this.translate.instant("general.headers.recurring"),
      field: "RecurrenceID",
      type: "recurrance"
    }
  ];
  public userDropDown: any = [];

  constructor(
    public technicianService: TechnicianService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.userDropDown = this.users
      .filter(user => {
        return (
          user.Email &&
          (user.TechnicianID === 0 ||
            user.TechnicianID === this.user.TechnicianID)
        );
      })
      .map(user => {
        return { label: user.Name + " " + user.Surname, value: user.ID };
      });
    this.userDropDown.sort(function(a, b) {
      if (a.label < b.label) return -1;
      if (a.label > b.label) return 1;
      return 0;
    });
    this.userDropDown.unshift({
      label: this.translate.instant(
        "bikeshop.modal.add_edit_user.technician_form.select_a_user_to_link"
      ),
      value: 0
    });
    this.getTechnician();
  }

  getTechnician() {
    this.technicianService
      .getTechnician(
        this.user.Technician ? this.user.Technician.ID : this.user.ID
      )
      .subscribe(technician => {
        this.technician = technician;
        this.getTechnicianEvents();
      });
  }

  getTechnicianEvents() {
    var startDate = new Date();
    var endDate = new Date();
    startDate.setDate(startDate.getDate() - 1);
    endDate.setMonth(endDate.getMonth() + 12);

    this.technicianService
      .getTechnicianEvents(
        this.technician.ID,
        startDate.toISOString(),
        endDate.toISOString()
      )
      .subscribe(events => {
        this.events = events.sort(function(a, b) {
          return (
            new Date(a.StartTime).getTime() - new Date(b.StartTime).getTime()
          );
        });
      });
  }

  deleteEvent(event) {
    this.busyDeleting = true;
    this.technicianService
      .cancelCalendarEvent(
        this.user.Technician ? this.user.Technician.ID : this.user.ID,
        event.ID,
        true
      )
      .subscribe(result => {
        this.getTechnicianEvents();
        this.busyDeleting = false;
      });
  }

  saveTechnician() {
    this.busy = true;
    this.technicianService.saveTechnician(this.technician).subscribe(
      technician => {
        this.busy = false;
        this.messageService.add({
          life: 5000,
          detail:
            "The technician details for " +
            (this.user.Name ? this.user.Name : this.user.Firstname) +
            " has been saved."
        });
        if (technician.UserID === 0) {
          delete this.user.Technician;
          this.user.TechnicianID = 0;
          this.update.emit(this.user);
        } else if (technician.UserID > 0) {
          var user = this.users.filter(user => {
            return user.Email && user.ID === technician.UserID;
          })[0];
          if (user) {
            delete user.Technician;
            user.Technician = technician;
            user.TechnicianID = technician.ID;
            this.update.emit(user);
          }
        }
      },
      err => {
        this.error = true;
        this.errorMessage =
          "You have reached you limit for adding technicians. You can make other technician inactive upgrade your plan";
      }
    );
  }
}
